// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/style/setting.less
// module id = 2268
// module chunks = 0